<template lang="html">
  <ValidationProvider rules="required|min:1" v-slot="{errors}" slim>
    <b-form-input
      autocomplete="off"
      :state="errors.length == 0"
      :value="propValue"
      @input="input"
      :type="type"
      :readonly="readonly"
      :placeholder="placeholder"
      @paste="removeEventSpaces"
      @drop="removeEventSpaces"
      :formatter="charHangulFomatter"
    ></b-form-input>
    <!-- <b-form-invalid-feedback :state="errors.length == 0">필수 입력 필요</b-form-invalid-feedback> -->
  </ValidationProvider>
</template>

<script>
import {charHangulFomatter, noSpaceFomatter} from '@/util/GeneralUtil';

export default {
  name: 'FormRequiredInputCharHangul',
  props: {
    value: {
      required: true,
      default: null,
    },
    type: String,
    readonly: Boolean,
    placeholder: {
      type: [Number, String],
    },
  },
  data() {
    return {
      propValInternal: '',
    };
  },
  computed: {
    propValue() {
      return this.value;
    },
  },
  methods: {
    charHangulFomatter: charHangulFomatter,
    input(value) {
      console.log(`input:${value}`);
      const regex = /[^가-힣a-zA-Zㄱ-ㅎㅏ-ㅣ]/g;
      const formatStr = value.match(regex)?.join('') || '';
      const replaceStr = value.replace(regex, '');
      console.log('replaceStr:' + replaceStr);
      //const pattern = / +/g;
      this.$emit('input', replaceStr);
    },
    removeEventSpaces(e) {
      e.preventDefault();
      console.log(e);
      const left = e.target.value.substring(0, e.target.selectionStart);
      const right = e.target.value.substring(e.target.selectionEnd, e.target.value.length);
      const pasted = (e.dataTransfer || e.clipboardData).getData('text').replace(/ /g, '');
      const regex = /[^가-힣a-zA-Zㄱ-ㅎㅏ-ㅣ]/g;
      const replaceStr = pasted.replace(regex, '');

      e.target.value = left + replaceStr + right;
      this.input(left + replaceStr + right);
    },
  },
};
</script>
